// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  DbmgrClusterWithMeta,
  TypesClusterMetadata,
  V1Neo4jCluster,
} from '../models/index';
import {
  DbmgrClusterWithMetaFromJSON,
  DbmgrClusterWithMetaToJSON,
  TypesClusterMetadataFromJSON,
  TypesClusterMetadataToJSON,
  V1Neo4jClusterFromJSON,
  V1Neo4jClusterToJSON,
} from '../models/index';

export interface ClustersClusteridDeleteRequest {
  clusterid: string;
}

export interface ClustersClusteridDiscoveryTopologyStatePostRequest {
  clusterid: string;
}

export interface ClustersClusteridGetRequest {
  clusterid: string;
  orchestra?: string;
}

export interface ClustersClusteridMetadataGetRequest {
  clusterid: string;
}

export interface ClustersClusteridPausePostRequest {
  clusterid: string;
}

export interface ClustersClusteridQuarantinePostRequest {
  clusterid: string;
}

export interface ClustersClusteridResumePostRequest {
  clusterid: string;
}

export interface ClustersClusteridRevokeQuarantinePostRequest {
  clusterid: string;
}

export interface ClustersClusteridTombstoneGetRequest {
  clusterid: string;
}

export interface ClustersGetRequest {
  orchestra: string;
}

/**
 *
 */
export class V2ClustersApi extends runtime.BaseAPI {
  /**
   * Destroy Neo4jCluster
   * Destroy Neo4jCluster
   */
  async clustersClusteridDeleteRaw(
    requestParameters: ClustersClusteridDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Destroy Neo4jCluster
   * Destroy Neo4jCluster
   */
  async clustersClusteridDelete(
    requestParameters: ClustersClusteridDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.clustersClusteridDeleteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Apply the discovery-topology-state-requested annotation to a Neo4jCluster, triggering the topology graph state reconciler.
   * Discovery Topology State on Neo4jCluster
   */
  async clustersClusteridDiscoveryTopologyStatePostRaw(
    requestParameters: ClustersClusteridDiscoveryTopologyStatePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridDiscoveryTopologyStatePost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/discovery_topology_state`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Apply the discovery-topology-state-requested annotation to a Neo4jCluster, triggering the topology graph state reconciler.
   * Discovery Topology State on Neo4jCluster
   */
  async clustersClusteridDiscoveryTopologyStatePost(
    requestParameters: ClustersClusteridDiscoveryTopologyStatePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.clustersClusteridDiscoveryTopologyStatePostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Neo4jCluster
   * Get Neo4jCluster
   */
  async clustersClusteridGetRaw(
    requestParameters: ClustersClusteridGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V1Neo4jCluster>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['orchestra'] != null) {
      queryParameters['orchestra'] = requestParameters['orchestra'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      V1Neo4jClusterFromJSON(jsonValue),
    );
  }

  /**
   * Get Neo4jCluster
   * Get Neo4jCluster
   */
  async clustersClusteridGet(
    requestParameters: ClustersClusteridGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V1Neo4jCluster> {
    const response = await this.clustersClusteridGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Neo4jCluster metadata, including tombstone if the cluster is deleted
   * Get Neo4jCluster metadata
   */
  async clustersClusteridMetadataGetRaw(
    requestParameters: ClustersClusteridMetadataGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TypesClusterMetadata>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridMetadataGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/metadata`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TypesClusterMetadataFromJSON(jsonValue),
    );
  }

  /**
   * Get Neo4jCluster metadata, including tombstone if the cluster is deleted
   * Get Neo4jCluster metadata
   */
  async clustersClusteridMetadataGet(
    requestParameters: ClustersClusteridMetadataGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TypesClusterMetadata> {
    const response = await this.clustersClusteridMetadataGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Scale down compute for a Neo4jCluster by setting spec.pause, retaining its volumes.
   * Pause Neo4jCluster
   */
  async clustersClusteridPausePostRaw(
    requestParameters: ClustersClusteridPausePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridPausePost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/pause`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Scale down compute for a Neo4jCluster by setting spec.pause, retaining its volumes.
   * Pause Neo4jCluster
   */
  async clustersClusteridPausePost(
    requestParameters: ClustersClusteridPausePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.clustersClusteridPausePostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Apply the quarantine label to a Neo4jCluster, isolating it from operator reconciliation.
   * Quarantine Neo4jCluster
   */
  async clustersClusteridQuarantinePostRaw(
    requestParameters: ClustersClusteridQuarantinePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridQuarantinePost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/quarantine`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Apply the quarantine label to a Neo4jCluster, isolating it from operator reconciliation.
   * Quarantine Neo4jCluster
   */
  async clustersClusteridQuarantinePost(
    requestParameters: ClustersClusteridQuarantinePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.clustersClusteridQuarantinePostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Scale compute back up for a paused Neo4jCluster by setting spec.pause, restoring the prior state in place.
   * Resume Neo4jCluster
   */
  async clustersClusteridResumePostRaw(
    requestParameters: ClustersClusteridResumePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridResumePost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/resume`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Scale compute back up for a paused Neo4jCluster by setting spec.pause, restoring the prior state in place.
   * Resume Neo4jCluster
   */
  async clustersClusteridResumePost(
    requestParameters: ClustersClusteridResumePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.clustersClusteridResumePostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Remove the quarantine label from a Neo4jCluster, returning it to normal operator reconciliation.
   * Revoke Neo4jCluster quarantine
   */
  async clustersClusteridRevokeQuarantinePostRaw(
    requestParameters: ClustersClusteridRevokeQuarantinePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<string>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridRevokeQuarantinePost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/revoke_quarantine`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    if (this.isJsonMime(response.headers.get('content-type'))) {
      return new runtime.JSONApiResponse<string>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Remove the quarantine label from a Neo4jCluster, returning it to normal operator reconciliation.
   * Revoke Neo4jCluster quarantine
   */
  async clustersClusteridRevokeQuarantinePost(
    requestParameters: ClustersClusteridRevokeQuarantinePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<string> {
    const response = await this.clustersClusteridRevokeQuarantinePostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get Cluster tombstone
   * Get Cluster tombstone
   */
  async clustersClusteridTombstoneGetRaw(
    requestParameters: ClustersClusteridTombstoneGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TypesClusterMetadata>> {
    if (requestParameters['clusterid'] == null) {
      throw new runtime.RequiredError(
        'clusterid',
        'Required parameter "clusterid" was null or undefined when calling clustersClusteridTombstoneGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters/{clusterid}/tombstone`;
    urlPath = urlPath.replace(
      `{${'clusterid'}}`,
      encodeURIComponent(String(requestParameters['clusterid'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      TypesClusterMetadataFromJSON(jsonValue),
    );
  }

  /**
   * Get Cluster tombstone
   * Get Cluster tombstone
   */
  async clustersClusteridTombstoneGet(
    requestParameters: ClustersClusteridTombstoneGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TypesClusterMetadata> {
    const response = await this.clustersClusteridTombstoneGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * List Neo4jClusters
   * List Neo4jClusters
   */
  async clustersGetRaw(
    requestParameters: ClustersGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<DbmgrClusterWithMeta>>> {
    if (requestParameters['orchestra'] == null) {
      throw new runtime.RequiredError(
        'orchestra',
        'Required parameter "orchestra" was null or undefined when calling clustersGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['orchestra'] != null) {
      queryParameters['orchestra'] = requestParameters['orchestra'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(DbmgrClusterWithMetaFromJSON),
    );
  }

  /**
   * List Neo4jClusters
   * List Neo4jClusters
   */
  async clustersGet(
    requestParameters: ClustersGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<DbmgrClusterWithMeta>> {
    const response = await this.clustersGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Create Neo4jCluster
   * Create Neo4jCluster
   */
  async clustersPostRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<V1Neo4jCluster>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/clusters`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      V1Neo4jClusterFromJSON(jsonValue),
    );
  }

  /**
   * Create Neo4jCluster
   * Create Neo4jCluster
   */
  async clustersPost(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<V1Neo4jCluster> {
    const response = await this.clustersPostRaw(initOverrides);
    return await response.value();
  }
}
